import { Navigate } from 'react-router-dom';

import { accountService } from 'services';
import { hasAccess } from 'utils';

export function PrivateRoute({ children, role }) {
  const user = accountService.userValue;
  return user ? (role && !hasAccess(user, role) ? <Navigate to={-1} /> : children) : <Navigate to="/account/login" />;
}
